import { render, staticRenderFns } from "./Checkouts.vue?vue&type=template&id=6166a734"
import script from "./Checkouts.vue?vue&type=script&lang=js"
export * from "./Checkouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports